window.onload = () => {
    const sidebarCollapse = document.getElementById("sidebar__collapse");
    const sidebarMenuButton = document.getElementById("sidebar__menu-button");
    const sidebar = document.querySelector('.sidebar');

    localStorage.setItem('sidebar-toggled', false);

    //if (sidebarToggled) toggle();

    function toggle() {
        const sidebarToggled = localStorage.getItem('sidebar-toggled') == 'true';

        const alertItem = document.querySelector('.alert-item');

        sidebar.classList.toggle('sidebar--toggled');
        sidebarMenuButton.classList.toggle('sidebar__menu-button--toggled');
        
        if (alertItem) {
            alertItem.classList.toggle('alert-item--sidebar-toggled');
        }

        if (sidebarMenuButton.classList.contains('sidebar__menu-button--toggled')) {
            sidebarMenuButton.children[0].src = '/assets/sidebar-menu-close.svg';


        } else {
            sidebarMenuButton.children[0].src = '/assets/sidebar-menu.svg';
        }

        localStorage.setItem('sidebar-toggled', !sidebarToggled);
    }

    if (sidebarCollapse && sidebarMenuButton) {
        sidebarCollapse.onclick = () => toggle();
        sidebarMenuButton.onclick = () => toggle();
    }
}
